import {
  DisciplineOutput,
  ExerciseOutput,
  QuestionOutput,
} from '@/api/gql/graphql';
import { Options } from '@/components/Common/Selects/Select.types';
import { create } from 'zustand';

export interface Exercise {
  id: number;
  title: string;
  content: string;
  duration: number;
}

type EvaluationStore = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpenModal: boolean) => void;
  exerciceTabs: Exercise[];
  setExerciceTabs: (exerciceTabs: Exercise[]) => void;
  evaluationList: QuestionOutput[];
  setEvaluationList: (evaluationList: QuestionOutput[]) => void;
  currentExerciseId: number | null;
  setCurrentExerciseId: (id: number | null) => void;
  activeTabExercise: number;
  setActiveTabExercise: (activeTabExercise: number) => void;
  exercice: ExerciseOutput | null;
  setExercice: (exercice: ExerciseOutput | null) => void;
  editingTab: boolean;
  setEditingTab: (editingTab: boolean) => void;
  isModalConfirmationExerciseOpen: boolean;
  setIsModalConfirmationExerciseOpen: (
    isModalConfirmationExerciseOpen: boolean,
  ) => void;
  isOpenEvaluationDeleteModal: boolean;
  setIsOpenEvaluationDeleteModal: (
    isOpenEvaluationDeleteModal: boolean,
  ) => void;
  selectedEvaluation: QuestionOutput | null;
  setSelectedEvaluation: (selectedEvaluation: QuestionOutput | null) => void;
  openEvaluationModal: () => void;
  setOpenEvaluationModal: (isOpen: boolean) => void;
  openDeleteEvaluationModal: () => void;
  setOpenDeleteEvaluationModal: (isOpen: boolean) => void;
  initialSelectedEvaluationOptions: Options | DisciplineOutput | null;
};

export const useEvaluationStore = create<EvaluationStore>((set) => ({
  isOpenModal: false,
  setIsOpenModal: (isOpenModal) => set({ isOpenModal }),
  exerciceTabs: [],
  setExerciceTabs: (exerciceTabs) => set({ exerciceTabs }),
  evaluationList: [],
  setEvaluationList: (evaluationList) => set({ evaluationList }),
  currentExerciseId: null,
  setCurrentExerciseId: (id) => set({ currentExerciseId: id }),
  activeTabExercise: 0,
  setActiveTabExercise: (activeTabExercise) => set({ activeTabExercise }),
  exercice: null,
  setExercice: (exercice) => set({ exercice }),
  editingTab: false,
  setEditingTab: (editingTab) => set({ editingTab }),
  isModalConfirmationExerciseOpen: false,
  setIsModalConfirmationExerciseOpen: (isModalConfirmationExerciseOpen) =>
    set({ isModalConfirmationExerciseOpen }),
  isOpenEvaluationDeleteModal: false,
  setIsOpenEvaluationDeleteModal: (isOpenEvaluationDeleteModal) =>
    set({ isOpenEvaluationDeleteModal }),
  selectedEvaluation: null,
  setSelectedEvaluation: (selectedEvaluation) => set({ selectedEvaluation }),
  openEvaluationModal: () =>
    set((state) => ({ isOpenModal: !state.isOpenModal })),
  setOpenEvaluationModal: (isOpen) => set({ isOpenModal: isOpen }),
  openDeleteEvaluationModal: () =>
    set((state) => ({
      isOpenEvaluationDeleteModal: !state.isOpenEvaluationDeleteModal,
    })),
  setOpenDeleteEvaluationModal: (isOpen) =>
    set({ isOpenEvaluationDeleteModal: isOpen }),
  initialSelectedEvaluationOptions: null,
}));
